var _path, _linearGradient, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Podium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#199be2",
    d: "M37,28h-2v-8.19c0-0.934-0.329-1.843-0.928-2.561l-3.841-4.609l1.537-1.28l3.841,4.609 C36.506,17.045,37,18.409,37,19.81V28z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ex_7ZV8XZpQ4oxP9qWZjPa",
    x1: 9,
    x2: 39,
    y1: 35,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#199ae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0782d8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ex_7ZV8XZpQ4oxP9qWZjPa)",
    d: "M9,29h30l-1.721,10.329C37.118,40.293,36.283,41,35.306,41H12.694 c-0.978,0-1.812-0.707-1.973-1.671L9,29z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3cf",
    d: "M39,30H9c-0.552,0-1-0.448-1-1v-1c0-0.552,0.448-1,1-1h30c0.552,0,1,0.448,1,1v1 C40,29.552,39.552,30,39,30z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 12,
    r: 3,
    fill: "#3cf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Podium);
export default __webpack_public_path__ + "static/media/icons8-podium.08bce71e8378dccc6df2857e24b8f92d.svg";
export { ForwardRef as ReactComponent };